<template>
    <div>
        <div v-if="isFavourite">
            <icon icon-name="custom:filled-star" medium />
        </div>
        <div v-else>
            <icon icon-name="custom:empty-star" medium />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isFavourite: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
};
</script>
